<template>
  <div class="grid-list">
    <div
      class="
        primary--text
        text--lighten-1 text-body-1 text-center
        font-weight-regular
      "
    >
      Faixa de preço
    </div>
    <v-sheet
      v-if="loading"
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="20"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>

    <div v-else class="mt-n1">
      <v-range-slider
        class="align-center"
        v-model="priceRange"
        :max="priceMax"
        :min="priceMin"
        :step="$route.path == '/locacao' ? 1000 : 100000"
        hide-details="hide-details"
      />

      <input name="min-price" :value="priceRangeStart" type="hidden" />
      <input name="max-price" :value="priceRangeEnd" type="hidden" />

      <div class="d-flex justify-space-between px-2 mt-n1">
        <div
          class="primary--text text--lighten-1 text-body-2 font-weight-medium"
        >
          {{ formatPrice(priceRangeStart) }}
        </div>
        <div
          class="primary--text text--lighten-1 text-body-2 font-weight-medium"
        >
          {{ formatPrice(priceRangeEnd) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "../../../utils/formatPrice";

const _data = {
  loading: true,
  priceRangeStart: 0,
  priceRangeEnd: 0,
  priceMax: 0,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest("properties").list;
    },
    price() {
      return this.$route.query.preco.split(",");
    },
    priceMin() {
      return 0;
    },
    priceRange: {
      get() {
        return [this.priceRangeStart, this.priceRangeEnd];
      },
      set(v) {
        this.priceRangeStart = v[0];
        this.priceRangeEnd = v[1];
      },
    },
  },
  methods: {
    getPriceMax() {
      this.loading = true;

      const params = {
        itemsPerPage: 1,
        returnMaxPrice: 1,
      };

      if (this.$route.path === "/locacao") params.business = "Aluguel";

      if (this.$route.path === "/imoveis") params.business = "Venda";

      if (this.$route.query.tipo) params.category = this.$route.query.tipo;
      else if (this.$route.path === "/terrenos")
        params.category = "Terreno, Terreno Comercial";
      else if (this.$route.path === "/rural")
        params.category = "Área,Chácara,Fazenda,Sítio";

      this.$rest("properties")
        .get({ params })
        .then((data) => {
          this.priceMax = data[0].price;
          if (this.priceMax > this.priceRangeEnd && !this.$route.query.preco)
            this.priceRangeEnd = data[0].price;
        })
        .finally(() => (this.loading = false));
    },
    formatPrice,
  },
  watch: {
    priceMax(v) {
      if (!this.priceRangeEnd) this.priceRangeEnd = v;
    },
    priceMin(v) {
      if (!this.priceRangeStart) this.priceRangeStart = v;
    },
    "$route.path"() {
      this.getPriceMax();
    },
  },
  created() {
    this.getPriceMax();
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  grid-template-columns: 1fr;
}
</style>
